export const TRANSITION_DURATION_MS = 1000;

export const DEFAULT_COLOR_SCHEME =
    import.meta.env.VITE_DEFAULT_COLOR_SCHEME ?? 'schemeYlOrBr';

export const CHARACTER_SET =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖabcdefghijklmnopqrstuvwxyzåäö0123456789+-−*/%,.²:'.split(
        ''
    );

export const FONT_FAMILY =
    'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';

export const FEATURES = {
    HUDDINGE_LOGIN: import.meta.env.VITE_FEATURE_HUDDINGE_LOGIN === 'true',
    PASSWORD_LOGIN: import.meta.env.VITE_FEATURE_PASSWORD_LOGIN === 'true',
    SHOW_REGRESSION_LINE:
        import.meta.env.VITE_FEATURE_SHOW_REGRESSION_LINE === 'true',
    LINK_TO_OM: import.meta.env.VITE_FEATURE_LINK_TO_OM === 'true',
    HIDE_FILTER_FEATURES_BOX:
        import.meta.env.VITE_HIDE_FILTER_FEATURES_BOX === 'true',
    SKIP_LANDING_PAGE:
        import.meta.env.VITE_FEATURE_SKIP_LANDING_PAGE === 'true',
    AI_PANEL: import.meta.env.VITE_FEATURE_AI_PANEL === 'true',
    LAN_PICKER: import.meta.env.VITE_FEATURE_LAN_PICKER === 'true',
};

export const defaultFeatureFilter: string =
    import.meta.env.VITE_PRIORITIZE_KOMMUN ?? '';

export const defaultFilterLabel: string =
    import.meta.env.VITE_DEFAULT_FILTER_LABEL ?? '';
